import React, { useState, useEffect, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Row, Col } from "reactstrap";
import { LIST_META, defaultPageSize } from "../../../config/constants";
import MasterFilterComponent from "./Component/MasterFilterComponent";
import {
  supplierListing,
  InviteNewSupplier,
} from "./Actions";
import PotentialEmployer from "./Component/PotentialEmployer";
import RegisteredEmployer from "./Component/RegisteredEmployer";
import LoaderCustom from "../../common/LoaderCustom";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import { TextFieldHookForm } from "../../layout/HookFormInputs";
import TooltipCustom from "../../common/Tooltip";
import Toaster from "../../common/Toaster";
import { ApplyPermissionSupplierOnboarding } from "./index";
import AddNewSupplier from "./AddSupplier";
import BlockedEmployer from "./Component/BlockedEmployer";

const AllSupplierRequestHistory = (props) => {
  // const { register, handleSubmit } = useForm();
  const permissions = useContext(ApplyPermissionSupplierOnboarding);
  const [noData, setNoData] = useState(false);
  const [loader, setLoader] = useState(false);
  const [globalTake, setGlobalTake] = useState(defaultPageSize);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [filter, setFilter] = useState("2");
  const [pageNo, setPageNo] = useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [sideBarFilterData, setSideBarFilterData] = useState(null);
  const [activeTab, setActiveTab] = useState("main");
  const [dataforUnblockingRequest, setDataForUnblockingRequest] = useState("show");
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    current_page: 1,
    per_page: globalTake,
    filter,
  });
  const { potentialEmployers, loading, registeredEmployer, blockedSuppliers } = useSelector(
    (state) => state?.AllSupplierHistorySlice
  );

  const getAllSupplierListing = () => {
    dispatch(
      supplierListing({
        filter,
        current_page: pageNo,
        per_page: filters.per_page,
      })
    );
  };

  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value // Switch the values here
    setFilter(selectedFilter);
    setPageNo(1);
    setFilters({
      ...filters,
      filter: selectedFilter,
      current_page: 1,
    });
  };
  function isValidEmail(email) {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }




  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    params.api.paginationGoToPage(0);
    window.screen.width >= 1366 && params.api.sizeColumnsToFit();
    // getAllSupplierListing(); // Call getAllSupplierListing after the grid is ready
  };

  useEffect(() => {
    // Function to fetch data after a 3-second delay
    const fetchDataWithDelay = async () => {
      // Show loader
      setLoader(true);

      // Simulate loading for 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 1000));

      try {
        // Fetch data after the delay
        await getAllSupplierListing();
      } catch (error) {

      } finally {
        // Hide loader after fetching data or encountering an error
        setLoader(false);
      }
    };

    // Call fetchDataWithDelay functio2n
    fetchDataWithDelay();
  }, [filter, pageNo]);

  const {
    register,
    setValue,
    getValues,
    reset,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const addForm = () => {
    setActiveTab("add");
  };
  const inviteSupplier = (data) => {
    setShowPopup(true);
  };



  const onBtPrevious = (p) => {
    setPageNo(p);

    // Dispatch the action with updated filters including the current page number
    dispatch(
      supplierListing({
        ...filters,
        current_page: p, // Update current page to the next page
      })
    );
  };

  const onBtNext = (p) => {
    // Update the pageNo state
    setPageNo(p);

    // Dispatch the action with updated filters including the current page number
    dispatch(
      supplierListing({
        ...filters,
        current_page: p, // Update current page to the next page
      })
    );
  };


  const onSortChanged = (event) => {
    const sortModel = event.api.getSortModel();
    let sortColumn = null;
    let sortOrder = null;
    if (sortModel && sortModel.length > 0) {
      sortColumn = sortModel[0].colId;
      sortOrder = sortModel[0].sort === "asc" ? "ASC" : "DESC";
    }
    dispatch(
      supplierListing({
        ...filters,
        sort_column: sortColumn,
        sort_order: sortOrder,
      })
    );
  };

  const handleMasterFilterChange = (values) => {
    
    // Log the values to see its structure
    // Update the filters state with the new values
    let filterData = {};
    setFilters((prevFilters) => {
      filterData = {
        ...prevFilters,
        ...values,
        current_page: 1,
        per_page: globalTake
      };
      return (filterData)
    });

    // Dispatch the action with the updated filters
    dispatch(
      supplierListing({
        ...filterData,
        ...values,
        current_page: 1,
      })
    );
  };

  const closePopUp = () => {
    setShowPopup(false);
    setValue("Email", "");
  };


  const onPopupConfirm = (Email) => {
    setLoader(true); // Set loading to true before initiating the API call
    const payload = {
      emailAddress: Email,
    };

    dispatch(
      InviteNewSupplier(payload, (res) => {
        reset();
        setLoader(false); // Set loading to false regardless of success or failure
        if (res && res.IsSuccessful) {
          Toaster.success(res?.FriendlyMessage);
          setShowPopup(false);
          setValue("Email", "");
        } else {
          Toaster.error(res?.response?.data?.ErrorMessage);
          setShowPopup(false);
        }
      })
    );
  };
  if (loading || loader) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is 2true
  }
  return (

    <>
      {activeTab === "main" ? (
        <>
          {loading && !props.usersWithSerialNumbers ? (
            <LoaderCustom customClass="simulation-Loader" />
          ) : (
            <>
              {dataforUnblockingRequest == "show" && (
                <Row className={`filter-row-large`}>
                  <Col md="3" lg="3" className="mb-2">
                    <h1>Supplier Repository</h1>
                  </Col>
                  <Col md="9" lg="9" className="mb-3 d-flex justify-content-end">
                    <div className="d-flex justify-content-end bd-highlight w100">
                      <>
                        {permissions?.Add && (
                          <button
                            type="button"
                            className="user-btn mr5"
                            title="Add Supplier"
                            onClick={() => {
                              addForm();
                            }}
                          >
                            <div className={"plus mr-0"}></div>
                          </button>
                        )}

                        <button
                          type="button"
                          className="user-btn mr5 mr-0"
                          title="Invite Supplier"
                          onClick={() => {
                            inviteSupplier();
                          }}
                        >
                          <div className="plus mr-2"></div> Invite
                        </button>
                        {/* {permissions?.Download && (
                    <button
                      type="button"
                      className="user-btn mr5"
                      title="Download All"
                      onClick={handleExcelDownload}
                    >
                      <div className="download"></div>All
                    </button>
                  )} */}

                      </>
                    </div>
                  </Col>
                </Row>)}
              <Row>
                {dataforUnblockingRequest == "show" && (
                  <Col span={24} md={2} className="hl-left-content">
                    <div className="registration-status pt-6 pt-4">
                      <label className="mb-3 block">Advanced Filter</label>
                      <div className="hl-radio-group">
                        <label>
                          <input
                            type="radio"
                            id="registeredSupplier"
                            name="filterOption"
                            value="1"
                            checked={filter === "1"}
                            onChange={handleFilterChange}
                          />
                          <span>Registered</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            id="potentialSupplier"
                            name="filterOption"
                            value="2"
                            checked={filter === "2"}
                            onChange={handleFilterChange}
                          />
                          <span>Potential Supplier</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            id="blockedSupplier"
                            name="filterOption"
                            value="3"
                            checked={filter === "3"}
                            onChange={handleFilterChange}

                          />
                          <span>Blocked</span>
                        </label>
                      </div>

                      <MasterFilterComponent
                        filter={filter}
                        onFilterChange={handleMasterFilterChange}
                        setSideBarFilterData={setSideBarFilterData}
                      />
                    </div>
                  </Col>)}
                <Col md={dataforUnblockingRequest == "show" ? "10" : "12"} className="ag-grid-react">
                  <div className="ag-theme-material">
                    {filter === "2" && (
                      <PotentialEmployer
                        filter={filter}
                        loading={loading}
                        onSortChanged={onSortChanged}
                        onGridReady={onGridReady}
                        usersWithSerialNumbers={potentialEmployers?.Data}
                        pageNo={pageNo}
                        filters={filters}
                        globalTake={globalTake}
                        setGlobalTake={setGlobalTake}
                        // onPageSizeChanged={onPageSizeChanged}
                        pageSize={LIST_META.per_page}

                        // pageSizeWrapper={pageSize}

                        onFilterChange={handleMasterFilterChange}
                        onBtPrevious={onBtPrevious}
                        onBtNext={onBtNext}
                        noData={noData}
                        sideBarFilterData={sideBarFilterData}
                      />
                    )}
                    {filter === "3" && (
                      <BlockedEmployer
                        filter={filter}
                        loading={loading}
                        onSortChanged={onSortChanged}
                        onGridReady={onGridReady}
                        usersWithSerialNumbers={blockedSuppliers?.Data}
                        pageNo={pageNo}
                        filters={filters}
                        globalTake={globalTake}
                        setGlobalTake={setGlobalTake}
                        // onPageSizeChanged={onPageSizeChanged}
                        pageSize={LIST_META.per_page}
                        // pageSizeWrapper={pageSize}
                        onFilterChange={handleMasterFilterChange}
                        onBtPrevious={onBtPrevious}
                        setDataForUnblockingRequest={setDataForUnblockingRequest}
                        onBtNext={onBtNext}
                        noData={noData}
                        sideBarFilterData={sideBarFilterData}
                      />
                    )}
                    {filter === "1" && (
                      <RegisteredEmployer
                      filter={filter}
                      loading={loading}
                      onSortChanged={onSortChanged}
                      onGridReady={onGridReady}
                      usersWithSerialNumbers={registeredEmployer?.Data}
                      pageNo={pageNo}
                      filters={filters}
                      globalTake={globalTake}
                      setGlobalTake={setGlobalTake}
                      // onPageSizeChanged={onPageSizeChanged}
                      pageSize={LIST_META.per_page}
                      // pageSizeWrapper={pageSize}
                      onFilterChange={handleMasterFilterChange}
                      onBtPrevious={onBtPrevious}
                      onBtNext={onBtNext}
                      noData={noData}
                      sideBarFilterData={sideBarFilterData}
                      />
                    )}
                    {showPopup && (
                      <PopupMsgWrapper
                        isOpen={showPopup}
                        firstButtonName="Send"
                        closePopUp={closePopUp}
                        header="Invite Supplier"
                        customClass="hl-invite-supplier"
                        confirmPopup={() => {
                          const emailValue = getValues("Email");
                          if (!emailValue) {
                            // Show error message
                            setEmailError(true);
                            return; // Prevent popup from closing
                          }

                          // Validate each email address
                          const emails = emailValue
                            .split(",")
                            .map((email) => email.trim());
                          const invalidEmails = emails.filter(
                            (email) => !isValidEmail(email)
                          );
                          if (invalidEmails.length > 0) {
                            // Show error message for invalid emails
                            setEmailError(true);
                            return; // Prevent popup from closing
                          }

                          setEmailError(false); // Reset error state if all emails are valid
                          onPopupConfirm(emailValue); // Proceed with sending
                        }}
                        message={
                          <>
                            <Col md="12" className="hl-error-cmtitle">
                              <TooltipCustom
                                id="businessYearTooltip"
                                width="350px"
                                tooltipText="Enter multiple emails separated by comma to initiate more than one request at a time."
                              />
                              <form>
                                <TextFieldHookForm
                                  {...register("Email")}
                                  label={`Email`}
                                  name={"Email"}
                                  Controller={Controller}
                                  control={control}
                                  placeholder={"Enter"}
                                  type={"email"} // Set input type to email for built-in email validation
                                  rules={{
                                    required: "This field is required.",
                                    maxLength: {
                                      value: 250,
                                      message:
                                        "Email must not exceed 50 characters.",
                                    },
                                    validate: {
                                      validEmails: (value) => {
                                        const emails = value
                                          .split(",")
                                          .map((email) => email.trim());
                                        const invalidEmails = emails.filter(
                                          (email) => !isValidEmail(email)
                                        );
                                        if (invalidEmails.length > 0) {
                                          return "Please enter valid email addresses separated by commas.";
                                        }
                                        return true;
                                      },
                                    },
                                  }}
                                  handleChange={() => setEmailError(false)} // Reset error state when input changes
                                  customClassName={"withBorder"}
                                  errors={errors.Email}
                                  mandatory={true}
                                />
                                {emailError && (
                                  <div className="text-help">
                                    This field is required.
                                  </div>
                                )}
                              </form>
                            </Col>
                          </>
                        }
                      />
                    )}
                  </div>
                </Col>
              </Row>
            </>
          )}
        </>
      ) : (
        activeTab === "add" && <AddNewSupplier />
      )}
    </>
  );
};

export default AllSupplierRequestHistory;
